import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

interface PersonagemImageLightboxProps {
  imageUrl: string | null;
  alt: string;
  onClose: () => void;
}

export const PersonagemImageLightbox: React.FC<PersonagemImageLightboxProps> = ({
  imageUrl,
  alt,
  onClose
}) => {
  if (!imageUrl) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-[60] p-6 animate-[fadeIn_0.1s_ease-out_forwards]"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-5 right-5 p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
        title="Fechar"
      >
        <X className="w-6 h-6" />
      </button>
      <img
        src={imageUrl}
        alt={alt}
        className="max-w-full max-h-full rounded-2xl shadow-2xl object-contain animate-[zoomIn95_0.15s_ease-out_forwards]"
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body
  );
};
